import { createForm, createFormField } from 'rc-form';
import { connect } from 'react-redux';
import { State } from '../../store';
import { actions, TFields } from '../../store/book';
import CarBookForm from './CarBookForm';

export default connect((state: State) => {
  return {
    bookState: state.book.fields,
  };
})(
  createForm({
    mapPropsToFields(props: { bookState: TFields }) {
      return Object.keys(props.bookState).reduce<{ [key: string]: any }>(
        (acc, fieldName) => {
          acc[fieldName] = createFormField(props.bookState[fieldName]);
          return acc;
        },
        {}
      );
    },
    onFieldsChange(props: any, fields: any) {
      props.dispatch(actions.updateFields(fields));
    },
  })(CarBookForm)
);
